const specialOccasions = {
  init() {
    this.meetingRfp();
  },

  meetingRfp() {
    const $plannerInputs = $('.planner-inputs');
    const $usingPlanner = $('.using-planner');

    $usingPlanner.on('change', () => {
      if ($('input[name="using_planner"]:checked').val() === 'Yes') {
        $plannerInputs.removeClass('hidden');
      } else {
        $plannerInputs.addClass('hidden');
      }
    });
  }
};

specialOccasions.init();
